/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import React from "react";
import { mixin } from "styles/mixin";

type Props = {
  className?: string;
  cssOverride?: SerializedStyles;
  dark?: boolean;
  lightColor?: string;
  darkColor?: string;
  size?: number;
};

export const HorizontalSymbolTextLogo: React.FC<Props> = ({
  className,
  cssOverride,
  dark = false,
  lightColor = "#444444",
  darkColor = "#ffffff",
  size = 32,
}) => {
  const color = dark ? darkColor : lightColor;
  return (
    <>
      <div
        css={[
          css`
            ${mixin.changeThemeFill};
            fill: ${color};
            display: flex; // MEMO: 縦の余分な計算ピクセルを消す
          `,
          cssOverride,
        ]}
        className={`${className ? className : ""}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={size}
          viewBox="0 0 784.8 147.43"
        >
          <g>
            <polygon points="205.07 77.39 234.67 47.9 221.51 47.9 195.97 73.87 195.97 47.9 186.08 47.9 186.08 113.35 195.97 113.35 195.97 86.33 198.01 84.21 221.62 113.35 234.9 113.35 205.07 77.39" />
            <path d="M288.9,43.71,257,113.35h10.83l7.24-15.9h27.71l7.29,15.9h10.74Zm9.78,44.51H279.23L288.89,66Z" />
            <polygon points="411.1 47.9 394.11 91.49 376.02 44.68 358.09 91.47 341.04 47.9 330.25 47.9 358.13 117.74 376.04 71.12 394.08 117.57 421.83 47.9 411.1 47.9" />
            <path d="M466.51,43.71l-31.88,69.64h10.83l7.24-15.9H480.4l7.29,15.9h10.74Zm9.78,44.51H456.84L466.5,66Z" />
            <rect x="533.67" y="47.9" width="9.89" height="65.45" />
            <path d="M611.54,55.62a24.43,24.43,0,0,1,16.28,6l1.65,1.41v-12l-.51-.29a34.52,34.52,0,0,0-32.34-.43,37.3,37.3,0,0,0-12.33,10.13,30.53,30.53,0,0,0-6.62,19.27,34.75,34.75,0,0,0,2.75,13.75,33.89,33.89,0,0,0,18.49,18.57,33.29,33.29,0,0,0,13,2.63A34,34,0,0,0,629,110.09l.5-.29v-12l-1.64,1.36c-5,4.18-10.5,6.3-16.29,6.3a22.93,22.93,0,0,1-16.81-7.28c-4.76-4.84-7.17-11-7.17-18.39a23.37,23.37,0,0,1,7.17-16.92A23,23,0,0,1,611.54,55.62Z" />
            <polygon points="702.13 47.9 702.13 73.38 673.85 73.38 673.85 47.9 663.92 47.9 663.92 113.35 673.85 113.35 673.85 82.78 702.13 82.78 702.13 113.35 711.98 113.35 711.98 47.9 702.13 47.9" />
            <rect x="754.02" y="47.9" width="9.89" height="65.45" />
            <path d="M31.05,99.24A58,58,0,0,1,118,24.3l-1.54,1.77A55.68,55.68,0,0,0,33,98Z" />
            <path d="M80.1,126.21h-.31A58,58,0,0,1,42.13,112.1l1.54-1.77A55.68,55.68,0,0,0,127.1,38.41l2-1.26a58,58,0,0,1-49,89.06Z" />
            <polygon
              points="85.26 76.06 67.8 91.17 85.26 106.28 85.26 76.06"
              style={{ fill: "none" }}
            />
            <polygon
              points="87.61 108.32 95.46 115.11 95.46 67.23 87.61 74.02 87.61 108.32"
              style={{ fill: "none" }}
            />
            <polygon
              points="97.8 117.14 116.06 132.94 116.06 49.4 97.8 65.2 97.8 117.14"
              style={{ fill: "none" }}
            />
            <path d="M132.74,21.25,59,84.79V36.91H56.68V86.81L35.35,105.19,36.89,107,56.68,89.91v47.83H59V87.88l.7-.6,58.69,50.8V36.7L134.28,23Zm-47.48,85L67.8,91.17,85.26,76.05Zm10.19,8.82-7.85-6.79V74l7.85-6.79Zm20.61,17.84L97.8,117.14V65.2L116.07,49.4Z" />
          </g>
        </svg>
      </div>
    </>
  );
};
